import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistProgress"];
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import LearningContentCard from '../../cards/components/LearningContentCard';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentItemProgress = _ref => {
  var _playlistProgress$pro;
  let {
      item: {
        playlistProgress
      },
      playlistId
    } = _ref,
    item = _objectWithoutPropertiesLoose(_ref.item, _excluded);
  const isCompleted = (playlistProgress === null || playlistProgress === void 0 ? void 0 : playlistProgress.status) === 'COMPLETED';
  const progressAmount = isCompleted ? 100 : (_playlistProgress$pro = playlistProgress === null || playlistProgress === void 0 ? void 0 : playlistProgress.progressLevel) !== null && _playlistProgress$pro !== void 0 ? _playlistProgress$pro : 0;
  return /*#__PURE__*/_jsx(LearningContentCard, {
    completionPercentage: progressAmount,
    "data-test-id": `item_progress_${item.id}`,
    footer: isCompleted ? /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      direction: "row",
      gap: 4,
      children: [/*#__PURE__*/_jsx(SuccessIcon, {
        color: "fill-positive-default"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.common.completed"
      })]
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      "data-test-id": "percentage-label",
      message: "learningCenter.playlistAssignments.complete",
      options: {
        percentage: /*#__PURE__*/_jsx(FormattedPercentage, {
          value: progressAmount
        })
      }
    }),
    item: item,
    overviewType: "playlist-assignments-monitor",
    playlistId: playlistId,
    renderMenu: () => null,
    size: "small"
  });
};
export default PlaylistAssignmentItemProgress;